import submissionRoutes from './submissionRoutes'
import wicRoutes from './wicRoutes'

const SidebarRoutes = () => {
  const userToken = JSON.parse(localStorage.getItem('okta-token-storage'))

  return userToken.accessToken.claims.role.includes('reviewer')
    ? wicRoutes
    : submissionRoutes
}

export default SidebarRoutes
